import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { Person } from "@/Common/Models/Person/Person";
import { IRelativeCreationModel } from "./UI/CreateRelativeUIModel";

class Relative extends Person {
    public HealthCardRegionLookupId: string;
    public NAMExpiry: Date;
    public Email: Email;
    public Address: Address;
    public PrimaryPhone: PhoneNumber;
    public SecondaryPhone: PhoneNumber;

    public constructor(fields?: Partial<Relative>) {
        super(fields);
    }

    public static FromRelativeCreationModel(relativeCreationModel: IRelativeCreationModel): Relative {
        const email = new Email();
        email.Address = relativeCreationModel.get("EmailEdit");
        email.ContactPointTypeLookupId = relativeCreationModel.get("EmailTypeByLookup");
        email.IsOkToContact = relativeCreationModel.get("IsOkToContact");
        email.NotificationsEnabled = relativeCreationModel.get("EmailNotificationsEnabled");
        email.ContactPoint_id = GuidHelper.NewGuid();

        const address = new Address();
        address.City = relativeCreationModel.get("CityEdit");
        address.StreetAddress = relativeCreationModel.get("CivicAddressEdit");
        address.ZipCode = relativeCreationModel.get("PostalCodeEdit");
        address.CountryLookupId = relativeCreationModel.get("SelectedCountryLookupId");
        address.StateLookupId = relativeCreationModel.get("SelectedRegionLookupId");
        address.ContactPoint_id = GuidHelper.NewGuid();

        const primaryPhone = new PhoneNumber();
        primaryPhone.Number = relativeCreationModel.get("Phone1Edit");
        primaryPhone.Extension = relativeCreationModel.get("Phone1Extension");
        primaryPhone.NotificationsEnabled = relativeCreationModel.get("Phone1NotificationsEnabled");
        primaryPhone.PhoneTypeLookupId = relativeCreationModel.get("Phone1TypeLookupId");
        primaryPhone.ContactPointTypeLookupId = relativeCreationModel.get("Phone1ContactTypeLookupId");
        primaryPhone.CountryLookupId = relativeCreationModel.get("SelectedCountryLookupId");
        primaryPhone.ContactPoint_id = GuidHelper.NewGuid();

        const secondaryPhone = new PhoneNumber();
        secondaryPhone.Number = relativeCreationModel.get("Phone2Edit");
        secondaryPhone.Extension = relativeCreationModel.get("Phone2Extension");
        secondaryPhone.NotificationsEnabled = relativeCreationModel.get("Phone2NotificationsEnabled");
        secondaryPhone.PhoneTypeLookupId = relativeCreationModel.get("Phone2TypeLookupId");
        secondaryPhone.ContactPointTypeLookupId = relativeCreationModel.get("Phone2ContactTypeLookupId");
        secondaryPhone.CountryLookupId = relativeCreationModel.get("SelectedCountryLookupId");
        secondaryPhone.ContactPoint_id = GuidHelper.NewGuid();

        const relative = new Relative();
        relative.LastName = relativeCreationModel.get("LastName");
        relative.FirstName = relativeCreationModel.get("FirstName");
        relative.PreferredName = relativeCreationModel.get("PreferredName");
        relative.DateOfBirth = relativeCreationModel.get("DOB");
        relative.GenderLookupId = relativeCreationModel.get("GenderLookupId");
        relative.GenderIdentity = relativeCreationModel.get("GenderIdentity");
        relative.PrefixLookupId = relativeCreationModel.get("SelectedPrefixLookupId");
        relative.PreferredPronouns = relativeCreationModel.get("PreferredPronouns");
        relative.SpecifiedPreferredPronouns = relativeCreationModel.get("SpecifiedPreferredPronouns");
        relative.HealthCardRegionLookupId = relativeCreationModel.get("SelectedHealthCardRegionLookupId");
        relative.NAM = relativeCreationModel.get("NAMEdit");
        relative.NAMExpiry = relativeCreationModel.get("NAMExpiryEdit");
        relative.Email = email;
        relative.Address = address;
        relative.PrimaryPhone = primaryPhone;
        relative.SecondaryPhone = secondaryPhone;

        return relative;
    }
}

export { Relative };
